import HTMLNode from "./html-node"
import HTMLNodeEmail from "./html-node-email"

export default {
  component: HTMLNode,
  email: HTMLNodeEmail,
  commands: {
    insertHTML(editor, { html }) {
      editor.insertBlock({
        type: "html",
        data: { html }
      })
    }
  },
  schema: {
    isVoid: true
  }
}
